import { DATE_CONSTANT } from '../constants';

export class DateUtils {
  /**
   * get the Next month by plus index
   * @param date The Date want to get next Month by index
   * @param numberMonths the nubmer weant to plus to get Month
   * @returns Date the next date by plus index number of Month
   */
  public static nextMonthOfDay(date: Date, numberMonths: number = 1): Date {
    const nextMonth = date.getMonth() + 1 + numberMonths; // get month return the index of month i
    const month =
      nextMonth > DATE_CONSTANT.month ? nextMonth % DATE_CONSTANT.month : nextMonth;

    // No Plus while month is same
    const plusYear =
      nextMonth === DATE_CONSTANT.month ? 0 : Math.floor(nextMonth / DATE_CONSTANT.month);

    // prevent the invalid day, Ex: date is 31/8/2023 and next month of date is 31/09/2023 => mark as 1 is the first day of month
    const nextDayOfMonth = 1;
    return new Date(date.getFullYear() + plusYear, month - 1, nextDayOfMonth);
  }

  /**
   * Get The prev Month by subs the index
   * @param {Date} date the date want to sub to get prev month by index
   * @param numberMonths the number watn to subs to get prev Month
   * @returns return new Date.
   */
  public static prevMonthOfDate(date: Date, numberMonths: number = 1): Date {
    const prevMonth = Math.abs(date.getMonth() + 1 - numberMonths);
    const subYearNumber = Math.floor(prevMonth / DATE_CONSTANT.month);
    const subMonthNumber =
      prevMonth > DATE_CONSTANT.month ? prevMonth % DATE_CONSTANT.month : 0;

    // if the month of value and the month next to sub is equal to 0, decreased 1 unit for the year
    if (date.getMonth() - subMonthNumber === 0) {
      return new Date(date.getFullYear() - 1, DATE_CONSTANT.month - 1, date.getDate());
    }

    // prevent the invalid day, Ex: date is 31/8/2023 and next month of date is 31/09/2023 => mark as 1 is the first day of month
    const _prevDayOfMonth = 1;
    return new Date(date.getFullYear() - subYearNumber, prevMonth - 1, _prevDayOfMonth);
  }

  /**
   * return a different bettween date
   * @param from from a date to compared
   * @param to a date need to check the different
   */
  public static comparedOnlyDates(from: Date, to: Date): number {
    const _from = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0);
    const _to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 0, 0, 0);
    return _from.getTime() - to.getTime();
  }

  /**
   * A function to calculate the date is belong to the range start and end
   * @param { Date } date current Date Node
   * @param { Date } start min Date
   * @param { Date } end Max Date
   * @returns boolean
   */
  public static isDateBelongToRanges(date: Date, start?: Date, end?: Date): boolean {
    const times = date.getTime();

    // always return as true if there are not ranges.
    if (!start && !end) {
      return true;
    }

    if (!start && end) {
      return end.getTime() - date.getTime() >= 0;
    }

    // in this line of code the start date can not be undefined but for passing the ts checked.
    const startTime = start?.getTime() || times + 1;
    if (start && !end) {
      return date.getTime() - startTime >= 0;
    }

    const endTime = end?.getTime() || 0;
    return times - startTime > -1 && endTime - times > -1;
  }
}
